<template>
  <div class="profile-container">
    <div class="card-container" ref="cardContainer">
      <div class="employee-card">
        <!-- Header with company info and QR -->
        <div class="card-header">
          <div class="header-content">
            <img src="https://ik.imagekit.io/lcpyg6uwo/img/512hklogo.png" alt="Company Logo" class="company-logo">
            <h1 class="company-name">CÔNG TY TNHH TM&XD HOÀNG KHẢI</h1>
          </div>
          <div class="qr-section">
            <qrcode-vue :value="userInfo?.userPrincipalName || ''" 
                       :size="60" 
                       level="H" 
                       render-as="svg"/>
          </div>
        </div>
        
        <!-- Main content with photo and info -->
        <div class="card-body">
          <div class="content-wrapper">
            <div class="photo-section">
              <img :src="userInfo?.photo || 'https://ik.imagekit.io/lcpyg6uwo/img/dl.png'" 
                   alt="Employee Photo" 
                   class="employee-photo">
              <div class="employee-id">Mã NV: 202505</div>
            </div>
            
            <div class="info-section">
              <div class="info-row">
                <label>Họ và tên:</label>
                <span>{{ userInfo?.displayName || 'Loading...' }}</span>
              </div>
              <div class="info-row">
                <label>Phòng ban:</label>
                <span>{{ userInfo?.department || 'Phòng Kỹ Thuật' }}</span>
              </div>
              <div class="info-row">
                <label>Email:</label>
                <span>{{ userInfo?.userPrincipalName || 'Loading...' }}</span>
              </div>
              <div class="info-row">
                <label>Điện thoại:</label>
                <span>{{ userInfo?.mobilePhone || 'Loading...' }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Business Card Section -->
    <div class="business-card-container" ref="businessCardContainer">
      <div class="business-cards-wrapper">
        <!-- Front Card -->
        <div class="business-card" ref="cardFront">
          <div class="card-front">
            <div class="logo-section">
              <img src="https://ik.imagekit.io/lcpyg6uwo/img/512hklogo.png" alt="Company Logo" class="front-logo">
            </div>
            <div class="card-details">
              <h2 class="company-name">CÔNG TY TNHH TM&XD HOÀNG KHẢI</h2>
              <div class="divider"></div>
              <p class="company-slogan">Trải nghiệm tương lai</p>
            </div>
          </div>
        </div>

        <!-- Back Card -->
        <div class="business-card" ref="cardBack">
          <div class="card-back">
            <div class="logo-section">
              <img src="https://ik.imagekit.io/lcpyg6uwo/img/512hklogo.png" alt="Company Logo" class="business-logo">
            </div>
            <div class="card-details">
              <h2 class="employee-name">{{ userInfo?.displayName || 'Loading...' }}</h2>
              <p class="job-title">Kỹ sư Phần mềm</p>
              <p class="position">{{ userInfo?.department || 'Phòng Kỹ Thuật' }}</p>
              <div class="divider"></div>
              <div class="contact-info">
                <p><i class="fas fa-phone"></i> {{ userInfo?.mobilePhone || '(+84) 915716898' }}</p>
                <p><i class="fas fa-envelope"></i> {{ userInfo?.userPrincipalName || 'Loading...' }}</p>
                <p><i class="fas fa-map-marker-alt"></i> Đồng Khoai, Phường Quảng Thành, Thành phố Thanh Hoá, Tỉnh Thanh Hoá, Việt Nam</p>
              </div>
            </div>
            <div class="qr-corner">
              <qrcode-vue :value="userInfo?.mobilePhone || ''" 
                         :size="50" 
                         level="H" 
                         render-as="svg"/>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="actions">
      <button @click="downloadCard" class="action-btn id-card-btn">
        <i class="fas fa-id-card"></i>
        <span>Tải thẻ nhân viên</span>
      </button>
      <button @click="downloadFullBusinessCard" class="action-btn full-card-btn">
        <i class="fas fa-id-badge"></i>
        <span>Tải Card Visit (2 mặt)</span>
      </button>
      <button @click="downloadBusinessCardFront" class="action-btn front-card-btn">
        <i class="fas fa-credit-card"></i>
        <span>Card Visit (Mặt trước)</span>
      </button>
      <button @click="downloadBusinessCardBack" class="action-btn back-card-btn">
        <i class="fas fa-credit-card fa-flip-horizontal"></i>
        <span>Card Visit (Mặt sau)</span>
      </button>
      <button @click="logout" class="action-btn logout-btn">
        <i class="fas fa-sign-out-alt"></i>
        <span>Đăng xuất</span>
      </button>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import api from '@/api/axios';
import { useAuthStore } from '@/stores/authStore';
import { useRouter } from 'vue-router';
import QrcodeVue from 'qrcode.vue';
import html2canvas from 'html2canvas';

const userInfo = ref(null);
const loading = ref(true);
const errorMessage = ref('');
const authStore = useAuthStore();
const router = useRouter();
const cardContainer = ref(null);
const businessCardContainer = ref(null);
const cardFront = ref(null);
const cardBack = ref(null);

const getUserInfo = async () => {
  try {
    const accessToken = authStore.accessToken;
    const response = await api.get('https://graph.microsoft.com/v1.0/me', {
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    const userValue = response.data;
    userInfo.value = response.data;
    console.log('User Info:', userValue);
    return userValue;
  } catch (error) {
    console.error('Error fetching user info:', error);
    router.push('/');
  } finally {
    loading.value = false;
  }
};

const logout = async () => {
  try {
    authStore.clearTokens();
    authStore.isAuthenticated = false;
    router.push('/');
  } catch (error) {
    errorMessage.value = error.response?.data?.message || 'Logout failed. Please try again.';
    console.error('Logout error:', error);
    authStore.clearTokens();
    authStore.isAuthenticated = false;
    router.push('/dang-nhap');
  }
};

const downloadCard = async () => {
  try {
    const element = cardContainer.value;
    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: null,
      logging: false,
      useCORS: true
    });

    const link = document.createElement('a');
    link.download = `employee-card-${userInfo.value?.displayName || 'user'}.png`;
    link.href = canvas.toDataURL('image/png');
    link.click();
  } catch (error) {
    console.error('Error generating card image:', error);
  }
};

const downloadBusinessCardFront = async () => {
  try {
    const element = cardFront.value;
    if (!element) {
      console.error('Card front element not found');
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: null,
      logging: false,
      useCORS: true,
      allowTaint: true,
      width: element.offsetWidth,
      height: element.offsetHeight,
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.querySelector('.card-front');
        if (clonedElement) {
          clonedElement.style.transform = 'none';
          clonedElement.style.borderRadius = '0';
          clonedElement.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
          
          // Áp dụng font cho các phần tử con
          const companyName = clonedElement.querySelector('.company-name');
          if (companyName) {
            companyName.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
            companyName.style.fontWeight = '600';
          }
          
          const slogan = clonedElement.querySelector('.company-slogan');
          if (slogan) {
            slogan.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
            slogan.style.fontStyle = 'italic';
          }
        }
      }
    });

    const link = document.createElement('a');
    link.download = `business-card-front-${userInfo.value?.displayName || 'user'}.png`;
    link.href = canvas.toDataURL('image/png', 1.0);
    link.click();
  } catch (error) {
    console.error('Error generating business card front:', error);
  }
};

const downloadBusinessCardBack = async () => {
  try {
    const element = cardBack.value;
    if (!element) {
      console.error('Card back element not found');
      return;
    }

    const canvas = await html2canvas(element, {
      scale: 2,
      backgroundColor: '#FFFFFF',
      logging: false,
      useCORS: true,
      allowTaint: true,
      width: element.offsetWidth,
      height: element.offsetHeight,
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.querySelector('.card-back');
        if (clonedElement) {
          clonedElement.style.transform = 'none';
          clonedElement.style.borderRadius = '0';
          clonedElement.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
          
          // Áp dụng font cho các phần tử con
          const elements = clonedElement.querySelectorAll('.employee-name, .job-title, .position, .contact-info p');
          elements.forEach(el => {
            el.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
          });

          const employeeName = clonedElement.querySelector('.employee-name');
          if (employeeName) {
            employeeName.style.fontWeight = '600';
          }

          const jobTitle = clonedElement.querySelector('.job-title');
          if (jobTitle) {
            jobTitle.style.fontWeight = '600';
          }
        }
      }
    });

    const link = document.createElement('a');
    link.download = `business-card-back-${userInfo.value?.displayName || 'user'}.png`;
    link.href = canvas.toDataURL('image/png', 1.0);
    link.click();
  } catch (error) {
    console.error('Error generating business card back:', error);
  }
};

// Thêm hàm mới để tải cả 2 mặt
const downloadFullBusinessCard = async () => {
  try {
    // Tạo canvas cho mặt trước
    const frontElement = cardFront.value;
    const frontCanvas = await html2canvas(frontElement, {
      scale: 2,
      backgroundColor: null,
      logging: false,
      useCORS: true,
      allowTaint: true,
      width: frontElement.offsetWidth,
      height: frontElement.offsetHeight,
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.querySelector('.card-front');
        if (clonedElement) {
          clonedElement.style.transform = 'none';
          clonedElement.style.borderRadius = '0';
          clonedElement.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
        }
      }
    });

    // Tạo canvas cho mặt sau
    const backElement = cardBack.value;
    const backCanvas = await html2canvas(backElement, {
      scale: 2,
      backgroundColor: '#FFFFFF',
      logging: false,
      useCORS: true,
      allowTaint: true,
      width: backElement.offsetWidth,
      height: backElement.offsetHeight,
      onclone: (clonedDoc) => {
        const clonedElement = clonedDoc.querySelector('.card-back');
        if (clonedElement) {
          clonedElement.style.transform = 'none';
          clonedElement.style.borderRadius = '0';
          clonedElement.style.fontFamily = "'Segoe UI', 'Roboto', 'Arial', sans-serif";
        }
      }
    });

    // Tạo canvas mới để ghép 2 mặt
    const finalCanvas = document.createElement('canvas');
    const ctx = finalCanvas.getContext('2d');
    
    // Đặt kích thước cho canvas cuối cùng (ngang gấp đôi)
    finalCanvas.width = frontCanvas.width * 2;
    finalCanvas.height = frontCanvas.height;
    
    // Vẽ mặt trước bên trái
    ctx.drawImage(frontCanvas, 0, 0);
    // Vẽ mặt sau bên phải
    ctx.drawImage(backCanvas, frontCanvas.width, 0);

    // Tải xuống ảnh ghép
    const link = document.createElement('a');
    link.download = `business-card-full-${userInfo.value?.displayName || 'user'}.png`;
    link.href = finalCanvas.toDataURL('image/png', 1.0);
    link.click();
  } catch (error) {
    console.error('Error generating full business card:', error);
  }
};

onMounted(getUserInfo);
</script>

<style scoped>
.profile-container {
  max-width: 600px;
  margin: 2rem auto;
  padding: 20px;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.card-container {
  background: white;
  border-radius: 15px;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  margin-bottom: 2rem;
  height: auto;
  min-height: fit-content;
}

.employee-card {
  height: 100%;
  display: flex;
  flex-direction: column;
}

.card-header {
  background: linear-gradient(135deg, #4CAF50, #FFC107);
  padding: 1.5rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-content {
  display: flex;
  align-items: center;
  gap: 1.5rem;
  flex: 1;
}

.company-logo {
  height: 60px;
  width: auto;
  filter: none;
  margin-right: 15px;
}

.company-name {
  font-size: 1.1rem;
  color: white;
  font-weight: 600;
  margin: 0;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
}

.card-body {
  flex: 1;
  padding: 1.5rem;
  height: auto;
  min-height: fit-content;
}

.content-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  height: auto;
  padding-bottom: 1rem;
}

.photo-section {
  width: 160px;
  height: auto;
  margin-top: 0rem;
  position: relative;
  z-index: 1;
  margin-bottom: 1rem;
  text-align: center;
}

.employee-photo {
  width: 100%;
  aspect-ratio: 3/4;
  object-fit: cover;
  border-radius: 10px;
  border: 4px solid white;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  margin-bottom: 8px;
}

.employee-id {
  font-size: 1rem;
  font-weight: 600;
  color: #4CAF50;
  padding: 4px 8px;
  border-radius: 4px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  display: inline-block;
  margin-top: 8px;
}

.info-section {
  width: 100%;
  padding-top: 1rem;
  height: auto;
}

.info-row {
  margin-bottom: 0.8rem;
  display: flex;
  align-items: baseline;
  gap: 1rem;
  border-bottom: 1px dashed #eee;
  padding-bottom: 0.5rem;
}

.info-row label {
  font-weight: 600;
  color: #4CAF50;
  min-width: 100px;
}

.info-row span {
  color: #333;
  flex: 1;
}

.qr-section {
  background: white;
  padding: 5px;
  border-radius: 5px;
  box-shadow: 0 2px 8px rgba(0,0,0,0.1);
}

/* Responsive adjustments */
@media (max-width: 768px) {
  .profile-container {
    padding: 10px;
    height: auto;
    min-height: 100vh;
  }

  .card-header {
    padding: 1rem;
    flex-direction: column;
    gap: 1rem;
  }

  .header-content {
    flex-direction: column;
    text-align: center;
  }

  .company-logo {
    height: 50px;
  }

  .company-name {
    font-size: 1rem;
  }

  .photo-section {
    width: 140px;
    margin-top: -2rem;
    margin-bottom: 0.5rem;
  }

  .employee-id {
    font-size: 0.9rem;
  }

  .info-row {
    flex-direction: column;
    gap: 0.3rem;
    text-align: center;
  }

  .info-row label {
    min-width: auto;
  }
}

.actions {
  display: grid;
  grid-template-columns: repeat(5, 1fr); /* Thay đổi thành 5 cột cố định */
  gap: 10px; /* Giảm khoảng cách giữa các nút */
  padding: 20px;
  max-width: 1200px; /* Tăng max-width để chứa đủ các nút */
  margin: 0 auto;
}

.action-btn {
  padding: 12px 16px; /* Giảm padding ngang */
  border: none;
  border-radius: 12px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px; /* Giảm khoảng cách giữa icon và text */
  transition: all 0.3s ease;
  white-space: nowrap;
  color: white;
  font-size: 13px; /* Giảm font size */
  min-height: 45px;
  width: 100%; /* Đảm bảo nút lấp đầy không gian */
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.action-btn i {
  font-size: 14px; /* Giảm kích thước icon */
}

.id-card-btn {
  background: linear-gradient(135deg, #3498db, #2980b9);
}

.id-card-btn:hover {
  background: linear-gradient(135deg, #2980b9, #2573a7);
  transform: translateY(-2px);
}

.front-card-btn {
  background: linear-gradient(135deg, #4CAF50, #45a049);
}

.front-card-btn:hover {
  background: linear-gradient(135deg, #45a049, #3d8b40);
  transform: translateY(-2px);
}

.back-card-btn {
  background: linear-gradient(135deg, #f1c40f, #f39c12);
}

.back-card-btn:hover {
  background: linear-gradient(135deg, #f39c12, #e67e22);
  transform: translateY(-2px);
}

.logout-btn {
  background: linear-gradient(135deg, #e74c3c, #c0392b);
}

.logout-btn:hover {
  background: linear-gradient(135deg, #c0392b, #a93226);
  transform: translateY(-2px);
}

.full-card-btn {
  background: linear-gradient(135deg, #6c5ce7, #a55eea);
}

.full-card-btn:hover {
  background: linear-gradient(135deg, #5b4cc4, #8f44e9);
  transform: translateY(-2px);
}

/* Responsive Design */
@media (max-width: 1200px) {
  .actions {
    grid-template-columns: repeat(3, 1fr); /* 3 nút mỗi hàng cho màn hình trung bình */
    max-width: 800px;
  }
}

@media (max-width: 768px) {
  .actions {
    grid-template-columns: 1fr; /* 1 nút mỗi hàng cho mobile */
    padding: 10px;
  }

  .action-btn {
    font-size: 14px; /* Tăng font size lại cho mobile */
    padding: 12px 20px;
  }
}

/* Responsive Design */
@media (max-width: 768px) {
  .card-body {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .photo-section {
    width: 120px;
    margin: 0 auto;
  }

  .info-row {
    flex-direction: column;
    gap: 0.3rem;
  }

  .info-row label {
    min-width: auto;
  }

  .qr-section {
    margin-top: 1rem;
  }

  .actions {
    grid-template-columns: 1fr;
    padding: 10px;
  }

  .action-btn {
    width: 100%;
    font-size: 13px;
  }
}

/* Print styles for better image generation */
@media print {
  .card-container {
    box-shadow: none;
  }
}

/* Business Card Styles */
.business-card-container {
  width: 100%;
  max-width: 800px;
  margin: 2rem auto;
  padding: 20px;
}

.business-cards-wrapper {
  display: flex;
  gap: 20px;
  justify-content: center;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.business-card {
  width: 350px;
  height: 200px;
  position: relative;
  border-radius: 8px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
}

.card-front {
  background: linear-gradient(135deg, #4CAF50, #FFC107);
  height: 100%;
  padding: 25px;
  display: grid;
  grid-template-rows: auto 1fr;
  gap: 15px;
  align-items: center;
}

.card-front .logo-section {
  text-align: center;
}

.front-logo {
  width: 70px;
  height: 70px;
  object-fit: contain;
  margin: 0 auto;
}

.card-front .card-details {
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.card-front .company-name {
  color: white;
  font-size: 14px;
  font-weight: bold;
  margin: 0;
  line-height: 1.4;
  max-width: 280px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  text-shadow: 1px 1px 2px rgba(0,0,0,0.1);
}

.card-front .divider {
  width: 60%;
  height: 2px;
  background: linear-gradient(90deg, #07daffd4, #f4f8f5);
  margin: 12px auto;
  box-shadow: 0 1px 2px rgba(0,0,0,0.1);
}


.card-front .company-slogan {
  color: white;
  font-size: 12px;
  font-style: italic;
  margin: 0;
  opacity: 0.9;
}

.card-back {
  background: white;
  height: 100%;
  padding: 20px;
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 15px;
}

.card-front, .card-back {
  position: relative;
  width: 100%;
  height: 100%;
  overflow: hidden;
  font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif;
}

.business-logo {
  width: 45px;
  height: 45px;
  object-fit: contain;
}

.card-details {
  text-align: left;
}

.employee-name {
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin: 0;
  font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif;
}

.job-title {
  font-size: 14px;
  color: #4CAF50;
  font-weight: 600;
  margin: 4px 0;
  font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif;
}

.position {
  font-size: 12px;
  color: #666;
  margin: 4px 0;
  font-style: italic;
  font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif;
}

.divider {
  width: 50%;
  height: 2px;
  background: linear-gradient(90deg, #4CAF50, #FFC107);
  margin: 8px 0;
}

.contact-info {
  margin-top: 10px;
  font-size: 11px;
  color: #555;
  font-family: 'Segoe UI', 'Roboto', 'Arial', sans-serif;
}

.contact-info p {
  margin: 4px 0;
  display: flex;
  align-items: center;
  gap: 6px;
}

.contact-info i {
  color: #4CAF50;
  width: 12px;
}

.qr-corner {
  position: absolute;
  top: 15px;
  right: 15px;
  background: white;
  padding: 4px;
  border-radius: 4px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.1);
}

@media (max-width: 768px) {
  .business-card {
    width: 300px;
    height: 170px;
  }

  .front-logo {
    width: 80px;
  }

  .card-front .company-name {
    font-size: 16px;
  }

  .business-logo {
    width: 40px;
  }

  .employee-name {
    font-size: 14px;
  }

  .contact-info {
    font-size: 10px;
  }
}
</style>
